/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokensRequest
 */
export interface RefreshTokensRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    readonly $schema?: string;
    /**
     * Device key
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    deviceKey: string;
    /**
     * Refresh token
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    refreshToken: string;
    /**
     * Sub
     * @type {string}
     * @memberof RefreshTokensRequest
     */
    sub: string;
}

/**
 * Check if a given object implements the RefreshTokensRequest interface.
 */
export function instanceOfRefreshTokensRequest(value: object): value is RefreshTokensRequest {
    if (!('deviceKey' in value) || value['deviceKey'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('sub' in value) || value['sub'] === undefined) return false;
    return true;
}

export function RefreshTokensRequestFromJSON(json: any): RefreshTokensRequest {
    return RefreshTokensRequestFromJSONTyped(json, false);
}

export function RefreshTokensRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokensRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'deviceKey': json['device_key'],
        'refreshToken': json['refresh_token'],
        'sub': json['sub'],
    };
}

export function RefreshTokensRequestToJSON(json: any): RefreshTokensRequest {
    return RefreshTokensRequestToJSONTyped(json, false);
}

export function RefreshTokensRequestToJSONTyped(value?: Omit<RefreshTokensRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_key': value['deviceKey'],
        'refresh_token': value['refreshToken'],
        'sub': value['sub'],
    };
}

